import cloneDeep from 'lodash/cloneDeep';
import difference from 'lodash/difference';
import pick from 'lodash/pick';

import { EntitySchema } from 'lib/schema';

// Constants
export const ENTITIES_KEY_FORM_LOGIC_RULE = 'formLogicRules';
export const LOGIC_PROPERTY_REQUIRED = 'required';
export const LOGIC_PROPERTY_LIMIT = 'limit';
export const LOGIC_PROPERTY_VISIBLE = 'visible';

// Defaults
export const FORM_LOGIC_DEFAULTS = {
    id: '',
    formId: null,
    property: null,
    target: null,
    targetType: null,
    defaultValue: null,
    defaultValueType: null,
    operandLeftType: null,
    operandLeft: null,
    operator: null,
    operandRightType: null,
    operandRight: null,
};

export const FORM_LOGIC_KEYS = Object.keys(FORM_LOGIC_DEFAULTS);

export const SERIALIZE_FORM_LOGIC_RULE_KEYS = difference(FORM_LOGIC_KEYS, ['id', 'formId']);

// Processors
const processFormLogicRuleEntity = (formLogicRule, parentNode) => {
    // extract formId from the parent node, which should be the root node for all logic rules.
    const { formId } = parentNode;
    return {
        ...cloneDeep(FORM_LOGIC_DEFAULTS),
        ...pick(formLogicRule, FORM_LOGIC_KEYS),
        formId,
    };
};

// Schemas
export const formLogicRuleSchema = new EntitySchema(
    ENTITIES_KEY_FORM_LOGIC_RULE,
    {},
    {
        processStrategy: processFormLogicRuleEntity,
        unprocessStrategy: SERIALIZE_FORM_LOGIC_RULE_KEYS,
        generateId: true,
    },
);
